import { useLibraryManager } from '@stores/LibraryManager/LibraryManager';
import { observer } from 'mobx-react';
import { AutoplayMomentsSwitch } from './AutoplayMomentsSwitch';
import css from './SearchHeader.module.scss';

export const SearchHeader = observer(function SearchHeader() {
  const libraryManager = useLibraryManager();
  const librarySearch = libraryManager.multiLibSearch;

  return (
    <div className={css.header}>
      <AutoplayMomentsSwitch />
    </div>
  );
});
